module.exports = " <section class=c-main__sub-section> <h3 class=\"c-main__sub-heading u-gutter\">API</h3> <div class=\"c-item u-gutter\"> <h4 class=c-item__heading>FocusTrap</h4> <h5 class=c-item__sub-heading>Props</h5> <app-table class=c-item__table :data=tables.props></app-table> <h5 class=c-item__sub-heading>Events</h5> <app-table class=c-item__table :data=tables.events></app-table> </div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/pages/HomeApiPage.vue
 ** module id = 86
 ** module chunks = 1
 **/